import Client from 'config/axios';
import posthog from 'posthog-js';

export const rejectSuggestedPost = async (
  token: string,
  id: any,
  message: string
) => {
  const body = {
    status: 'rejected',
    points: 0,
    message: message
  };
  const { data } = await Client.post(
    `suggested_post/aprove_reject/${id}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  posthog.capture('Rechazar Propuesta de Campaña', {
    rejectSuggestedPost: data
  });
  return {
    data
  };
};
